import React, { useState, useEffect } from "react";
import Images from "../Helper/AllImages";
import { AddLiquidity } from "../PopModals/AddLiquidity_Modal";
import Withdraw_Modal from "../PopModals/Withdraw_Modal";
import { useSelector } from "react-redux";
import axios from "axios";
import { CRYPTOCOMPARE_KEY } from "../../Services/environment";

const TableBody = ({
  d,
  Key,
  setKeyState,
  keyState,
  closeAll,
  setCloseAll,
  setPoolBalance,
}) => {
  const decimalValue = {
    BTC: 8,
    ETH: 18,
    BCH: 8,
    LTC: 8,
    THOR: 8,
    BNB: 8,
  };
  const [showModal, setShowModal] = React.useState(false);
  const midgardPool = useSelector((state) => state.main.midgardPool);
  const runeData = useSelector((state) => state.main.runeData);

  const [poolData, setPoolData] = useState({});
  const [priceInUSD, setPriceInUSD] = useState("");
  useEffect(async () => {
    let asset = gettingAssetName(d?.pool);
    let chain = gettingChainName(d?.pool);
    let decimal;
    switch (chain.toLowerCase()) {
      case "eth":
        decimal = decimalValue.ETH;
        break;
      case "bnb":
        decimal = decimalValue.BNB;
        break;
      case "bch":
        decimal = decimalValue.BCH;
        break;
      case "btc":
        decimal = decimalValue.BTC;
        break;
      case "rune":
        decimal = decimalValue.THOR;
        break;
      case "ltc":
        decimal = decimalValue.LTC;
        break;
      default:
        break;
    }
    let priceInUSD = await axios.get(
      `https://min-api.cryptocompare.com/data/price?fsym=${asset}&tsyms=USD&api_key=${CRYPTOCOMPARE_KEY}`
    );
    let runeAdded = Number(d?.runeAdded / Math.pow(10, decimal));
    let runeAddedUSD = runeAdded * Number(runeData.assetPriceUSD);

    let res = midgardPool?.find(
      (t) => t?.rawData.toLowerCase() === d?.pool.toString().toLowerCase()
    );
    res.assetDepthUSD = res?.assetDepth * priceInUSD?.data?.USD;
    const addedUSD =
      (d?.assetAdded / Math.pow(10, decimal)) * priceInUSD?.data?.USD +
      runeAddedUSD;
    d.assetAddedUSD = addedUSD;
    setPoolBalance(Number(addedUSD));
    setPriceInUSD(priceInUSD?.data?.USD);
    setPoolData(res);
  }, []);
  useEffect(() => {
    if (Key !== keyState) {
      setShowModal(false);
    }
  }, [closeAll]);
  const handlePopUpModal = () => {
    setKeyState(Key);
    setCloseAll(!closeAll);
    setShowModal(true);
  };
  const gettingLogos = (data) => {
    let asset = gettingAssetName(data);

    let res = midgardPool?.find(
      (d) => d?.asset.toLowerCase() === asset?.toLowerCase()
    );
    return (
      <img
        src={res?.logo}
        width="24px"
        height="24px"
        style={{ marginRight: "6px" }}
      />
    );
  };
  const gettingAssetName = (data) => {
    let v = data?.split("-");
    let c = v[0]?.split(".");
    return c[1];
  };
  const gettingChainName = (data) => {
    let v = data?.split("-");
    let c = v[0]?.split(".");
    return c[0];
  };

  function financialRoundOff(x) {
    return Number.parseFloat(x).toFixed(0);
  }
  function financial(x) {
    return Number.parseFloat(x).toFixed(2);
  }
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return (
    <>
      <tr>
        <td>
          <div
            class="d-flex"
            style={{ cursor: "pointer" }}
            onClick={handlePopUpModal}
          >
            {/* <img src={d.image} style={{ width: "32px", height: "32px" }} />
             */}
            {gettingLogos(d?.pool)}
            <div class="pl-3">
              <div class="n-tabelDark">{gettingAssetName(d?.pool)}</div>
              <div class="d-flex align-items-center">
                <div class=" text-muted">{gettingChainName(d?.pool)}</div>
              </div>
            </div>
          </div>
          {showModal ? (
            <div className="mt-3" style={{ display: "flex" }}>
              <AddLiquidity data={poolData} />
              <Withdraw_Modal data={poolData} liquidityData={d} />
            </div>
          ) : null}
        </td>

        <td
          className="text-right"
          style={{ cursor: "pointer" }}
          onClick={handlePopUpModal}
        >
          <span className="depositclasss n-depositClass">
            {financialRoundOff(poolData?.poolAPY * 100)}% APY
          </span>
        </td>
        <td
          className="text-right"
          style={{ cursor: "pointer" }}
          onClick={handlePopUpModal}
        >
          <div
            style={{
              textAlign: "end",
            }}
            class="n-tabelDark"
          >
            ${numberWithCommas(financial(poolData?.assetDepthUSD))}
            {/* BTC */}
          </div>
          <div>
            <div
              class=" text-muted "
              style={{
                textAlign: "end",
              }}
            >
              ${numberWithCommas(financial(priceInUSD))}
            </div>
          </div>
        </td>
        <td
          className="text-right"
          style={{ cursor: "pointer" }}
          onClick={handlePopUpModal}
        >
          <div
            style={{
              textAlign: "end",
            }}
            class="n-tabelDark"
          >
            ${numberWithCommas(financial(d?.assetAddedUSD))}
            {/* BTC */}
          </div>
          <div>
            <div
              class=" text-muted "
              style={{
                textAlign: "end",
              }}
            >
              ${numberWithCommas(financial(priceInUSD))}
            </div>
          </div>
        </td>
        <td
          className="text-right"
          style={{ cursor: "pointer" }}
          onClick={handlePopUpModal}
        >
          <div
            class="d-flex justify-content-end n-tabelDark"
            style={{
              textAlign: "end",
            }}
          >
            {d.Interest}
            {/* BTC */}
          </div>
          <div class="d-flex justify-content-end">
            <div
              class=" text-muted"
              style={{
                textAlign: "end",
              }}
            >
              ${d.Price}
            </div>
          </div>
        </td>
      </tr>
    </>
  );
};

export default TableBody;
